exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1N9l8WX7{background-color:#f0f0f0}._2hdNxdT2{font-weight:600;display:inline-block}._2IG5m4Nm{margin:40px}._3izPjtMr{display:block;float:right}._3izPjtMr button{font-size:14px}._18BHh1d8{visibility:hidden}._1GfeTIE2{z-index:1001;position:absolute;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";opacity:1;bottom:calc(50% - 100px);left:calc(50% - 100px);background-color:#e0e0e0;padding:10px;border:1px solid #000}._20pYVPXC{display:block;position:relative;padding:16px;color:#414141;font-weight:400;white-space:normal}._20pYVPXC ._3ELFm5fj{display:block;font-size:18px;letter-spacing:.54px;line-height:18px;font-weight:700;margin-bottom:8px}._20pYVPXC .K77Vj6Ou p{font-size:14px;line-height:19.6px;letter-spacing:0;margin-bottom:10px;color:#414141}._20pYVPXC .K77Vj6Ou p.EVitaOFF{font-weight:500}", ""]);

// exports
exports.locals = {
	"submit-btn": "_1N9l8WX7",
	"name-label": "_2hdNxdT2",
	"fields-container": "_2IG5m4Nm",
	"button-aria": "_3izPjtMr",
	"wcag-invisible": "_18BHh1d8",
	"bookmarks-batch-edit-modal": "_1GfeTIE2",
	"warning-container": "_20pYVPXC",
	"warning-title": "_3ELFm5fj",
	"warning-content": "K77Vj6Ou",
	"medium": "EVitaOFF"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[hash:base64:8]"}!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist!./src/note/bookmarks/style.less
// module id = 1334
// module chunks = 2